/* Upsell panier latéral — tiroir panier Impulse. Aucune dépendance au code interne du thème. */
(function () {
  'use strict';
  var root = document.getElementById('CartUpsellSide');
  var drawer = document.getElementById('CartDrawer');
  if (!root || !drawer) return;

  var DESKTOP_MIN = 1000;
  var list = root.querySelector('[data-cus-list]');
  var cfg = root.dataset;
  var limit = parseInt(cfg.limit, 10) || 4;
  var cache = {};
  var lastSignature = null;
  var loading = false;

  /* ---------- Utilitaires ---------- */
  function cents(v) {
    if (v === null || v === undefined || v === '') return 0;
    if (typeof v === 'string') return Math.round(parseFloat(v) * 100);
    return v;
  }
  function formatMoney(c) {
    var fmt = cfg.moneyFormat || '{{amount_with_comma_separator}} €';
    function delim(n, prec, th, dec) {
      var p = (n / 100).toFixed(prec).split('.');
      var whole = p[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + th);
      return whole + (p[1] ? dec + p[1] : '');
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      switch (k) {
        case 'amount': return delim(c, 2, ',', '.');
        case 'amount_no_decimals': return delim(c, 0, ',', '.');
        case 'amount_with_comma_separator': return delim(c, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return delim(c, 0, '.', ',');
        case 'amount_with_space_separator': return delim(c, 2, ' ', ',');
        case 'amount_with_apostrophe_separator': return delim(c, 2, "'", '.');
        default: return delim(c, 2, '.', ',');
      }
    });
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }
  function img(src, w) {
    if (!src) return '';
    if (typeof src === 'object') src = src.src || src.url || '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function getJSON(url) {
    return fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); });
  }

  /* Normalise un produit (format recommandations ou format collection products.json) */
  function normalize(p) {
    var variants = (p.variants || []).map(function (v) {
      return { id: v.id, title: v.title, available: v.available !== false, price: cents(v.price), compare: cents(v.compare_at_price) };
    });
    var avail = variants.filter(function (v) { return v.available; });
    if (!avail.length) return null;
    var first = avail[0];
    return {
      id: p.id,
      title: p.title,
      url: p.url || ('/products/' + p.handle),
      image: p.featured_image || (p.images && p.images[0]) || (p.media && p.media[0] && p.media[0].src) || '',
      variants: variants,
      single: variants.length === 1,
      price: first.price,
      compare: first.compare
    };
  }

  /* ---------- Données ---------- */
  function recosFor(productId, intent) {
    var key = productId + ':' + intent;
    if (cache[key]) return Promise.resolve(cache[key]);
    var url = cfg.recoUrl + '.json?product_id=' + productId + '&limit=' + (limit + 4) + '&intent=' + intent;
    return getJSON(url).then(function (d) { cache[key] = d.products || []; return cache[key]; })
      .catch(function () { return []; });
  }
  function collectionProducts(handle, n) {
    var key = 'col:' + handle;
    if (cache[key]) return Promise.resolve(cache[key]);
    return getJSON(cfg.collectionsUrl + '/' + handle + '/products.json?limit=' + n)
      .then(function (d) { cache[key] = d.products || []; return cache[key]; })
      .catch(function () { return []; });
  }

  /* ---------- Familles de produits ----------
     bonnet    : bonnets tube, cagoules (proposés UNIQUEMENT si un hijab est dans le panier)
     hijab     : hijabs, khimars, foulards, écharpes
     accessory : vrais accessoires — bijoux, sacs, pochettes, ceintures
     clothing  : tout le reste (le titre « ROBE … CEINTURE » reste un vêtement) */
  function norm(s) {
    return String(s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
  }
  var RX_BONNET = /\b(bonnets?|cagoules?|underscarf)\b/;
  var RX_HIJAB = /\b(hijabs?|khimars?|foulards?|chales?|echarpes?|turbans?)\b|carre de soie/;
  var RX_CLOTHING = /^(maxi\s+)?(robes?|ensembles?|sets?|pantalons?|jupes?|blouses?|tops?|chemises?|blazers?|vestes?|manteaux?|trenchs?|gilets?|cardigans?|pulls?|abayas?|kimonos?|palazzos?|jeans?|tuniques?|burkinis?|coats?|capes?|ponchos?|sweats?|salopettes?|basic|bohemian|polos?|t-shirts?|dress)\b/;
  var RX_ACCESSORY = /\b(sacs?|pochettes?|boucles? d.oreilles?|bijoux?|colliers?|bracelets?|bagues?|ceintures?|broches?)\b/;
  var colKind = null; // id produit -> famille d'après sa collection (secours quand le titre ne dit rien)
  function loadKinds() {
    if (colKind) return Promise.resolve(colKind);
    var acc = (cfg.accessoryCollections || '').split(',').map(function (h) { return h.trim(); }).filter(Boolean);
    var hij = cfg.hijabCollection || 'hijabs';
    return Promise.all([collectionProducts(hij, 250)].concat(acc.map(function (h) { return collectionProducts(h, 250); })))
      .then(function (lists) {
        colKind = {};
        lists.forEach(function (l, i) { l.forEach(function (p) { if (!colKind[p.id]) colKind[p.id] = i === 0 ? 'hijab' : 'accessory'; }); });
        return colKind;
      });
  }
  function kindOf(title, id) {
    var t = norm(title);
    if (RX_BONNET.test(t)) return 'bonnet';
    if (RX_CLOTHING.test(t)) return 'clothing';
    if (RX_HIJAB.test(t)) return 'hijab';
    if (RX_ACCESSORY.test(t)) return 'accessory';
    return (colKind && colKind[id]) || 'clothing';
  }

  /* Réserves de secours par famille */
  function interleave(lists) {
    var out = [], i = 0, more = true;
    while (more) { more = false; lists.forEach(function (l) { if (l[i]) { out.push(l[i]); more = true; } }); i++; }
    return out;
  }
  function poolFor(kind) {
    var acc = (cfg.accessoryCollections || '').split(',').map(function (h) { return h.trim(); }).filter(Boolean);
    var hij = cfg.hijabCollection || 'hijabs';
    if (kind === 'accessory') return Promise.all(acc.map(function (h) { return collectionProducts(h, 250); })).then(interleave);
    if (kind === 'bonnet') return Promise.all(acc.concat([hij]).map(function (h) { return collectionProducts(h, 250); })).then(function (l) { return [].concat.apply([], l); });
    if (kind === 'hijab') return collectionProducts(hij, 250);
    return collectionProducts(cfg.clothingCollection, 40);
  }

  /* Bonnets : ceux dont la couleur rappelle le hijab du panier passent devant */
  var STOP = /^(bonnet|bonnets|tube|hijab|hijabs|maxi|jersey|liquid|premium|lux|luxe|satine|soie|de|du|la|le|les|et|en|a)$/;
  function words(t) { return norm(t).split(/[^a-z0-9]+/).filter(function (w) { return w.length > 2 && !STOP.test(w); }); }
  function byColour(cands, refTitles) {
    var ref = {};
    refTitles.forEach(function (t) { words(t).forEach(function (w) { ref[w] = true; }); });
    return cands.map(function (c, i) {
      var s = words(c.title).filter(function (w) { return ref[w]; }).length;
      return { c: c, s: s, i: i };
    }).sort(function (a, b) { return b.s - a.s || a.i - b.i; }).map(function (x) { return x.c; });
  }

  function collect(cart) {
    var inCart = {};
    cart.items.forEach(function (i) { inCart[i.product_id] = true; });
    var ids = [];
    cart.items.forEach(function (i) { if (ids.indexOf(i.product_id) === -1) ids.push(i.product_id); });
    ids = ids.slice(0, 3);

    return loadKinds().then(function () {
      var kinds = cart.items.map(function (i) { return kindOf(i.product_title, i.product_id); });
      var last = kinds[0]; // dernier article ajouté
      var hijabTitles = cart.items.filter(function (i, n) { return kinds[n] === 'hijab'; }).map(function (i) { return i.product_title; });
      var hasBonnet = kinds.indexOf('bonnet') > -1;

      // Ordre des suggestions : [famille, nombre maximum]
      var plan = [];
      if (last === 'accessory') {
        plan.push(['clothing', limit]);               // bijou / sac -> vêtements
      } else {
        if (hijabTitles.length && !hasBonnet) plan.push(['bonnet', 2]); // hijab -> bonnets tube assortis
        if (last === 'bonnet') plan.push(['hijab', 2]);                  // bonnet -> hijabs
        plan.push(['accessory', limit]);              // vêtement -> bijoux, sacs, pochettes, ceintures
      }
      setTitle(last !== 'accessory');

      return Promise.all(ids.map(function (id) { return recosFor(id, 'complementary'); }))
        .then(function (r1) {
          return Promise.all(ids.map(function (id) { return recosFor(id, 'related'); })).then(function (r2) { return [].concat.apply([], r1.concat(r2)); });
        })
        .then(function (recos) {
          return Promise.all(plan.map(function (p) { return poolFor(p[0]); })).then(function (pools) {
            var out = [], seen = {};
            plan.forEach(function (p, n) {
              var cands = recos.concat(pools[n]).filter(function (raw) {
                return !inCart[raw.id] && !seen[raw.id] && kindOf(raw.title, raw.id) === p[0];
              });
              if (p[0] === 'bonnet') cands = byColour(cands, hijabTitles);
              var taken = 0;
              cands.forEach(function (raw) {
                if (out.length >= limit || taken >= p[1] || seen[raw.id]) return;
                var it = normalize(raw);
                if (it) { seen[raw.id] = true; out.push(it); taken++; }
              });
            });
            return out;
          });
        });
    });
  }

  var titleEl = root.querySelector('[data-cus-title]');
  function setTitle(acc) {
    if (!titleEl) return;
    titleEl.textContent = acc ? (cfg.titleAccessories || titleEl.textContent) : (cfg.titleClothing || titleEl.textContent);
  }

  /* ---------- Rendu ---------- */
  function itemHTML(p) {
    var sale = p.compare > p.price;
    var price = '<span class="cus__price' + (sale ? ' cus__price--sale' : '') + '"><span data-cus-price>' + formatMoney(p.price) + '</span>' +
      (sale ? '<s data-cus-compare>' + formatMoney(p.compare) + '</s>' : '') + '</span>';
    var picker = '';
    if (!p.single) {
      picker = '<select class="cus__select" data-cus-variant aria-label="Taille / option">' +
        p.variants.map(function (v) {
          return '<option value="' + v.id + '" data-price="' + v.price + '" data-compare="' + v.compare + '"' + (v.available ? '' : ' disabled') + '>' +
            esc(v.title) + (v.available ? '' : ' — épuisé') + '</option>';
        }).join('') + '</select>';
    }
    var firstAvail = p.variants.filter(function (v) { return v.available; })[0];
    return '<div class="cus__item">' +
      '<a class="cus__img" href="' + esc(p.url) + '">' + (p.image ? '<img src="' + esc(img(p.image, 200)) + '" alt="' + esc(p.title) + '" loading="lazy" width="200" height="267">' : '') + '</a>' +
      '<div class="cus__info"><a class="cus__name" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' + price +
      '<div class="cus__form" data-cus-form data-variant="' + firstAvail.id + '">' + picker +
      '<button type="button" class="cus__add" data-cus-add>Ajouter</button><p class="cus__msg" data-cus-msg hidden></p></div></div></div>';
  }

  function render(products) {
    if (!products.length) { root.hidden = true; list.innerHTML = ''; return; }
    list.innerHTML = products.map(itemHTML).join('');
    // Présélectionne la première option disponible
    list.querySelectorAll('[data-cus-form]').forEach(function (f) {
      var s = f.querySelector('[data-cus-variant]');
      if (s) s.value = f.dataset.variant;
    });
    root.hidden = false;
    place();
  }

  function refresh(force) {
    if (loading) return;
    loading = true;
    getJSON(cfg.cartUrl + '.js').then(function (cart) {
      var sig = cart.items.map(function (i) { return i.product_id; }).join(',');
      if (!cart.item_count) { lastSignature = sig; root.hidden = true; list.innerHTML = ''; return; }
      if (!force && sig === lastSignature && list.children.length) { root.hidden = false; place(); return; }
      lastSignature = sig;
      return collect(cart).then(render);
    }).catch(function () {}).then(function () { loading = false; });
  }

  /* ---------- Placement (côté desktop / bandeau mobile) ---------- */
  function isOpen() {
    return drawer.classList.contains('drawer--is-open') ||
      document.documentElement.classList.contains('js-drawer-open-right');
  }
  function place() {
    var desktop = window.innerWidth >= DESKTOP_MIN;
    if (desktop) {
      if (root.parentNode !== document.body) document.body.appendChild(root);
      root.classList.add('cus--side');
      root.classList.remove('cus--inline');
      var dw = drawer.offsetWidth || drawer.getBoundingClientRect().width;
      var w = Math.min(300, Math.max(0, window.innerWidth - dw - 16));
      root.style.width = w + 'px';
      root.style.right = dw + 'px';
      root.classList.toggle('is-open', isOpen() && !root.hidden && w >= 220);
    } else {
      var scroll = drawer.querySelector('.drawer__scrollable');
      var products = drawer.querySelector('[data-products]');
      if (scroll && products && root.previousElementSibling !== products) {
        products.insertAdjacentElement('afterend', root);
      }
      root.classList.remove('cus--side', 'is-open');
      root.classList.add('cus--inline');
      root.style.width = root.style.right = '';
    }
  }

  /* ---------- Ajout au panier ---------- */
  function itemCountInDrawer() {
    var el = drawer.querySelector('[data-products] [data-count]');
    return el ? parseInt(el.getAttribute('data-count'), 10) : null;
  }
  function manualRebuild() {
    // Secours si le thème n'a pas reconstruit le tiroir lui-même
    return fetch(cfg.cartUrl + '?view=ajax', { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var items = doc.querySelector('.cart__items');
        var target = drawer.querySelector('[data-products]');
        if (!items || !target) return;
        target.innerHTML = doc.body.innerHTML;
        var sub = drawer.querySelector('[data-subtotal]');
        if (sub) sub.innerHTML = formatMoney(parseInt(items.getAttribute('data-cart-subtotal'), 10));
        drawer.classList.remove('is-empty');
      });
  }
  function add(btn) {
    var form = btn.closest('[data-cus-form]');
    var sel = form.querySelector('[data-cus-variant]');
    var id = sel ? sel.value : form.dataset.variant;
    var msg = form.querySelector('[data-cus-msg]');
    btn.disabled = true;
    btn.textContent = 'Ajout…';
    msg.hidden = true;
    fetch(cfg.addUrl + '.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1 }] })
    }).then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); })
      .then(function (d) {
        var before = itemCountInDrawer();
        document.dispatchEvent(new CustomEvent('cart:build'));
        setTimeout(function () {
          getJSON(cfg.cartUrl + '.js').then(function (cart) {
            var shown = itemCountInDrawer();
            if (shown === null || shown !== cart.item_count) return manualRebuild();
          }).catch(function () {});
          // Pastille du panier dans l'en-tête
          document.querySelectorAll('.cart-link__bubble').forEach(function (b) { b.classList.add('cart-link__bubble--visible'); });
        }, 700);
        btn.textContent = 'Ajouté ✓';
        setTimeout(function () { refresh(true); }, 900);
        return before;
      })
      .catch(function (e) {
        btn.disabled = false;
        btn.textContent = 'Ajouter';
        msg.textContent = (e && (e.description || e.message)) || 'Impossible d’ajouter ce produit.';
        msg.hidden = false;
      });
  }

  /* ---------- Événements ---------- */
  // Les clics/focus dans le panneau ne doivent pas fermer le tiroir ni être captés par le piège de focus du thème
  ['click', 'mousedown', 'touchstart', 'focusin'].forEach(function (t) {
    root.addEventListener(t, function (e) { e.stopPropagation(); }, false);
  });
  root.addEventListener('click', function (e) {
    var b = e.target.closest('[data-cus-add]');
    if (b && !b.disabled) add(b);
  });
  root.addEventListener('change', function (e) {
    var s = e.target.closest('[data-cus-variant]');
    if (!s) return;
    var o = s.options[s.selectedIndex];
    var item = s.closest('.cus__item');
    var price = parseInt(o.dataset.price, 10), compare = parseInt(o.dataset.compare, 10);
    var pe = item.querySelector('[data-cus-price]');
    if (pe) pe.textContent = formatMoney(price);
    var ce = item.querySelector('[data-cus-compare]');
    if (ce) ce.textContent = compare > price ? formatMoney(compare) : '';
  });

  // Ouverture / fermeture du tiroir
  var wasOpen = false;
  function onDrawerState() {
    var open = isOpen();
    if (open && !wasOpen) refresh(false);
    wasOpen = open;
    place();
    setTimeout(place, 350);
  }
  new MutationObserver(onDrawerState).observe(drawer, { attributes: true, attributeFilter: ['class', 'style'] });
  new MutationObserver(onDrawerState).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });

  // Contenu du tiroir reconstruit (ajout, suppression, quantité)
  var t;
  function onCartChange() { clearTimeout(t); t = setTimeout(function () { refresh(false); }, 250); }
  var products = drawer.querySelector('[data-products]');
  if (products) new MutationObserver(function () { onCartChange(); place(); }).observe(products, { childList: true });
  ['cart:build', 'ajaxProduct:added', 'cart:open'].forEach(function (ev) {
    document.addEventListener(ev, function () { if (ev === 'cart:open') onDrawerState(); onCartChange(); });
  });
  window.addEventListener('resize', function () { place(); });

  place();
  if (isOpen()) refresh(false);
})();
